import React from 'react';
import PropTypes from 'prop-types';
import { Attachments } from '../../../dashboardCommon/components';
import { apiHost } from '../../../../utils/request';

const pdfLinks = [
  {
    label: 'Contract PDF',
    getUrl: (orderId, locale) =>
      `${apiHost}/orders/${orderId}/fully-managed-quote-pdf?lang=${locale}`
  }
];

const Attachements = props => (
  <Attachments {...props} pdfLinks={pdfLinks} cardHeaderTitle="Contract PDF" />
);

Attachements.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.shape({})).isRequired
};

export default Attachements;
